import React, { useState, useEffect,useContext  } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation   } from 'react-router-dom';
import { FaFilter, FaSortAmountDown, FaSortAmountUp  } from 'react-icons/fa';
import Loader from '../components/Loader';
import FeedbackWidget from '../components/FeedbackWidget';
import Navbar from './Navbar';
import ExportExcel from './ExportExcel';
import Plot from "react-plotly.js";
import { UserContext } from '../contexts/UserContext';
import nonCompliance from '../assets/data/nonCompliance.json';
import axios from 'axios';
import ReactMarkdown from 'react-markdown'; 
import { CONFIG} from '../config';    

const DLScoreCard = () => {
  //const apiUrl='https://divapilotfalcon-hdbqdbd4gxccdmdd.eastus-01.azurewebsites.net/report-data';
  //const apiUrl='https://divadevfalcon.azurewebsites.net/report-data';
  const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/report-data';
  const [expanded, setExpanded] = useState({});
  const [filterVisible, setFilterVisible] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});  
  const [allSelected, setAllSelected] = useState(false);
  const [selectedSort, setSelectedSort] = useState('');
  const [searchText, setSearchText] = useState("");
  const [displayEmpName, setDisplayEmpName] = useState("");
  const [displayTmsName, setdisplayTmsName] = useState("");
  const [displayMu, setDisplayMu] = useState("");
  const [displayMarket, setDisplayMarket] = useState("");
  const [openModal, setOpenModal] = useState(false);  
  const [openTmsModal, setOpenTmsModal] = useState(false);  
  const [sortOrder, setSortOrder] = useState('asc');
  const { userId } = useContext(UserContext);
  console.log('userId',userId);
  const [filteredData, setFilteredData] = useState([]);
  const [marketList, setMarketList] = useState([]);
  const [marketListValue, setMarketListValue] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [checkListValue, setCheckListValue] = useState([]);
  const [DLScore, setDLScore] = useState([]);
  const [top5List, setTop5List] = useState([]);
  const [top5ListValue, setTop5ListValue] = useState([]);
  const [muTop5List, setMuTop5List] = useState([]);
  const [muTop5ListValue, setMuTop5ListValue] = useState([]);
  const [checksDetials, setChecksDetials] = useState([]);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [dlScoreData, setDlScoreData] = useState([]);
  const [tolEmpCheckCount, setTolEmpCheckCount] = useState([]);
  const [displayFilterOptionsList, setDisplayFilterOptionsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isExpanded, setIsExpanded] = useState(true);
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = useState(true);  
  const [showModal, setShowModal] = useState(false);

  
  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };


  useEffect(() => {    
    if (!userId) return;
   const postData=JSON.stringify({"user_id":userId});
   try {
   axios.post(apiUrl,postData)
    .then(response => {
      if( response && response.data){
        console.log('response.data',response.data);
        const defaultExpanded = {};
      var mlistArray=[];
      const mlist=[];
      const mlistValue=[];
      var kpi=0;
      var isa=0;
      var tool=0;
      var training=0;
      var review=0;
      var totalDLScore=0;      
      response.data.structured_data = [...response.data.structured_data].sort((a, b) => {
        const keyA = Object.keys(a)[0];
        const keyB = Object.keys(b)[0];
        return keyA.localeCompare(keyB);
      });
      response.data.structured_data.forEach((market) => {
        const marketName = Object.keys(market)[0];
        mlistArray.push({'marketName':marketName,'value':market?.[marketName]?.market_level_metrics?.Total});
        totalDLScore+=market?.[marketName]?.market_level_metrics?.Total;
        //mlistValue.push(market?.[marketName]?.market_level_metrics?.Total);
        kpi += (typeof market?.[marketName]?.market_level_metrics?.['Delivery Governance KPIs'] === 'number' && isFinite(market?.[marketName]?.market_level_metrics?.['Delivery Governance KPIs'])) 
       ? market?.[marketName]?.market_level_metrics?.['Delivery Governance KPIs'] 
       : 0;
       isa += (typeof market?.[marketName]?.market_level_metrics?.['ISA Compliance tracking KPIs'] === 'number' && isFinite(market?.[marketName]?.market_level_metrics?.['ISA Compliance tracking KPIs'])) 
       ? market?.[marketName]?.market_level_metrics?.['ISA Compliance tracking KPIs'] 
       : 0;
       tool += (typeof market?.[marketName]?.market_level_metrics?.['ATCI Tool KPIs'] === 'number' && isFinite(market?.[marketName]?.market_level_metrics?.['ATCI Tool KPIs'])) 
       ? market?.[marketName]?.market_level_metrics?.['ATCI Tool KPIs'] 
       : 0;
       training += (typeof market?.[marketName]?.market_level_metrics?.['Training KPIs'] === 'number' && isFinite(market?.[marketName]?.market_level_metrics?.['Training KPIs'])) 
       ? market?.[marketName]?.market_level_metrics?.['Training KPIs'] 
       : 0;
       review += (typeof market?.[marketName]?.market_level_metrics?.['Review KPIs'] === 'number' && isFinite(market?.[marketName]?.market_level_metrics?.['Review KPIs'])) 
       ? market?.[marketName]?.market_level_metrics?.['Review KPIs'] 
       : 0;
        defaultExpanded[`market-${marketName}`] = false;
      });
  
      
      mlistArray= mlistArray.sort((a, b) => a.value - b.value);
     // mlistArray= mlistArray.sort((a, b) => b.marketName.localeCompare(a.marketName));
      mlistArray.forEach((m) => {
        mlist.push(m.marketName);
        mlistValue.push(m.value);
      })
      var checklistArray=[{'name':'Review Compliance','value':review},{'name':'Training Compliance','value':training},{'name':'Tool Compliance','value':tool},{'name':'ISA Compliance','value':isa},{'name':'Delivery Governance KPI','value':kpi}];
      checklistArray= checklistArray.sort((a, b) => a.value - b.value);
      var chlistName=[];
      var chListValue=[];
      checklistArray.forEach((m) => {
        chlistName.push(m.name);
        chListValue.push(m.value);
      })
      setCheckList(chlistName);
      setCheckListValue(chListValue);
      setMarketList(mlist);
      setMarketListValue(mlistValue);
      setDLScore(totalDLScore);
      setDlScoreData(response.data);
      setData(response.data.structured_data);
      setFilteredData(response.data.structured_data);
    
  
      setExpanded(defaultExpanded);
      
      setSelectedFilter(response.data.structured_data.map(d => Object.keys(d)[0]));  
      
      var top5Name=[];
      var top5Value=[];
      response.data.top_5_line_items= response.data.top_5_line_items.sort((a, b) => a.count - b.count);
      response.data.top_5_line_items.forEach((ch) => {
        top5Name.push(ch.line_item);
        top5Value.push(ch.count);
      })
      setTop5List(top5Name);
      setTop5ListValue(top5Value);
  
      var top5muName=[];
      var top5muValue=[];
      response.data.top_3_market_units= response.data.top_3_market_units.sort((a, b) => a.total_count - b.total_count);
      response.data.top_3_market_units.forEach((mus) => {
        top5muName.push(mus.market_unit);
        top5muValue.push(mus.total_count);
      })
      setMuTop5List(top5muName);
      setMuTop5ListValue(top5muValue);
   }
    })
    .catch(error => {
       if(error?.response?.data?.error){
        navigate(`/erroraccess`);
      }
    })
  } catch (err) {
    setError("Failed to fetch data.");
  } finally {
   // setLoading(true);
  }
    
  }, [userId]);

  const toggle = (key) => {
    //setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
    setExpanded((prev) => {
      const newValue = !prev[key];
      const updated = { ...prev, [key]: newValue };
      console.log('New value for', key, ':', newValue);
      return updated;
    });
  };

  const handleCheckboxChange = (value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [value]: !prev[value],
    }));
  };

  function keepOnlyKey(obj, keyToKeep) {
    Object.keys(obj).forEach(key => {
      if (key !== keyToKeep) {
        delete obj[key];
      }
    });
    return obj;
  }

  const filterByNestedKey = (arr, targetKey, market) => {
    var bObj = structuredClone(data.find(obj => obj[market]));
    const zItem = bObj?.[market].mu_level_metrics.find(obj => obj[targetKey]);
    bObj[market].mu_level_metrics=[zItem]
    return bObj;
    }
 // };

 function getEmpDataOnly(data,market,mu,emp) {
  const bObj = structuredClone(data.find(obj => obj[market]));
  const zItem = bObj?.[market].mu_level_metrics.find(obj => obj[mu]);
  const dlObj = zItem?.[mu+'_dl_level_metrics'];
  if (!dlObj || typeof dlObj !== 'object' || !dlObj.hasOwnProperty(emp)) {
    return null;
  }

    keepOnlyKey(zItem[mu+'_dl_level_metrics'],emp);
  // Assign filtered key directly back into original object
  
  bObj[market].mu_level_metrics = [zItem];
  const mudata=bObj[market].mu_level_metrics.find(obj => obj.hasOwnProperty(mu))
  bObj[market].mu_level_metrics=[mudata];
  return bObj;
  }

 function getEmpDataTmsOnly(data,market,mu,emp,tms) {
  const bObj = structuredClone(data.find(obj => obj[market]));
  const zItem = bObj?.[market]?.mu_level_metrics.find(obj => obj[mu]);
  const dlObj = zItem?.[mu+'_dl_level_metrics'][emp].tms_level;
  if (!dlObj || typeof dlObj !== 'object' || !dlObj.hasOwnProperty(tms)) {
    return null;
  }
  zItem[mu+'_dl_level_metrics'][emp].tms_level={ [tms]: dlObj[tms] };
  
  //zItem=empObj;
   // console.log(keepOnlyKey(zItem[mu+'_dl_level_metrics'],emp))
  // Assign filtered key directly back into original object
  bObj[market].mu_level_metrics = [zItem];
  const mudata=bObj[market].mu_level_metrics.find(obj => obj.hasOwnProperty(mu))
  bObj[market].mu_level_metrics=[mudata];
  const empData=bObj[market].mu_level_metrics[0][mu+'_dl_level_metrics'][emp];
  bObj[market].mu_level_metrics[0][mu+'_dl_level_metrics']={ [emp]: empData }
  //const empdata=bObj[market].mu_level_metrics.find(obj => obj.hasOwnProperty(mu))
  //bObj[market].mu_level_metrics=mudata;
  return bObj;
  }

  function getPrefixPathsOnly(paths) {
    const set = new Set(paths);
    return paths.filter(path => {
      const parts = path.split('->');
      for (let i = 1; i < parts.length; i++) {
        const parent = parts.slice(0, i).join('->');
        if (set.has(parent)) {
          return false;
        }
      }
      return true;
    });
  }
  


  const handleApply = () => {
   
    const selectedValues = Object.keys(selectedOptions).filter((key) => selectedOptions[key]);
    var FValue=[];
    if (selectedValues.length === 0) {
      setFilteredData(data.map(d => Object.keys(d)[0]));
      //setFilteredData(contractDemographicsWeb.contract_demographics_web.tmsList); // No filter, show all
    } else {
      console.log('selectedValues',selectedValues);
      var finalSelectedValue=getPrefixPathsOnly(selectedValues);
      console.log('finalSelectedValue',finalSelectedValue);     
      var defaultExpanded=[];   
      
    finalSelectedValue.map(value => {
        const type=value.split("->");
        if(type && type.length===1)
        {
          const mselArray=data.filter(obj => obj.hasOwnProperty(type[0]));
          console.log('mselArray',mselArray);
          FValue.push(...mselArray);          
          defaultExpanded[`market-${type[0]}`]=false;
        }
        if(type && type.length===2)
          {
            const mselArray=filterByNestedKey(data,type[1],type[0])
            console.log('mselArray',mselArray);
            FValue.push(mselArray);
            defaultExpanded[`mu-${type[0]}-${type[1]}`] = false;         
          }
          if(type && type.length==3){
            const mselArray=getEmpDataOnly(data,type[0],type[1],type[2])
            console.log('mselArray',mselArray);
            FValue.push(mselArray);
            defaultExpanded[`mu-${type[0]}-${type[1]}-emp-${type[2]}`] =false;       
          }
          if(type && type.length==4){
            const mselArray=getEmpDataTmsOnly(data,type[0],type[1],type[2],type[3])
            console.log('mselArray',mselArray);
            FValue.push(mselArray);
            defaultExpanded[`mu-${type[0]}-${type[1]}-emp-${type[2]}`] =false; 
          }
           });
      console.log('defaultExpanded',defaultExpanded);
      console.log('FValue',FValue);
      const fMValue=mergeHierarchy(FValue);
      console.log('mergeObjectr',fMValue);     
      setExpanded(defaultExpanded);
      setFilteredData(fMValue);


      // const newFilteredData = contractDemographicsWeb.contract_demographics_web.tmsList.filter((row) =>
      //  selectedValues.includes(row[filterColumn]?.toString())
      // );
     // setFilteredData(newFilteredData); //  Update filtered data
    }
     expandAll();
    setFilterVisible(false);
    //setExpanded(defaultExpanded);   
  // setLoading(false);
  };

  function isObject(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
  }
  
  // Merge two objects deeply
  function deepMerge(target, source) {
    if (Array.isArray(target) && Array.isArray(source)) {
      return mergeArrays(target, source);
    }
  
    const result = { ...target };
  
    for (const key of Object.keys(source)) {
      const srcVal = source[key];
      const tgtVal = result[key];
  
      if (isObject(tgtVal) && isObject(srcVal)) {
        result[key] = deepMerge(tgtVal, srcVal);
      } else if (Array.isArray(tgtVal) && Array.isArray(srcVal)) {
        result[key] = mergeArrays(tgtVal, srcVal);
      } else {
        result[key] = srcVal;
      }
    }
  
    return result;
  }
  
  // Merge arrays of objects by their keys
  function mergeArrays(arr1, arr2) {
    const result = [...arr1];
  
    for (const item2 of arr2) {
      let merged = false;
  
      for (let i = 0; i < result.length; i++) {
        const item1 = result[i];
  
        // Try merging if both are objects and share same top key
        if (isObject(item1) && isObject(item2)) {
          const keys1 = Object.keys(item1);
          const keys2 = Object.keys(item2);
  
          if (keys1.length === 1 && keys2.length === 1 && keys1[0] === keys2[0]) {
            result[i] = {
              [keys1[0]]: deepMerge(item1[keys1[0]], item2[keys2[0]])
            };
            merged = true;
            break;
          }
        }
      }
  
      if (!merged) {
        result.push(item2);
      }
    }
  
    return result;
  }
  
  function mergeDeep(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) {
      const result = [];
      const used = new Array(b.length).fill(false);
  
      for (const itemA of a) {
        let merged = false;
        for (let i = 0; i < b.length; i++) {
          if (!used[i] && isObject(itemA) && isObject(b[i])) {
            const keysA = Object.keys(itemA);
            const keysB = Object.keys(b[i]);
            if (keysA.some(k => keysB.includes(k))) {
              result.push(mergeDeep(itemA, b[i]));
              used[i] = true;
              merged = true;
              break;
            }
          }
        }
        if (!merged) result.push(itemA);
      }
  
      for (let i = 0; i < b.length; i++) {
        if (!used[i]) result.push(b[i]);
      }
  
      return result;
    } else if (isObject(a) && isObject(b)) {
      const result = { ...a };
      for (const key in b) {
        if (result.hasOwnProperty(key)) {
          result[key] = mergeDeep(result[key], b[key]);
        } else {
          result[key] = b[key];
        }
      }
      return result;
    } else {
      return b;
    }
  }
  
  function isObject(val) {
    return typeof val === 'object' && val !== null && !Array.isArray(val);
  }
  
  function mergeHierarchy(arr) {
    const resultMap = {};
    for (const obj of arr) {
      for (const key in obj) {
        if (resultMap[key]) {
          resultMap[key] = mergeDeep(resultMap[key], obj[key]);
        } else {
          resultMap[key] = obj[key];
        }
      }
    }
    return Object.entries(resultMap).map(([key, value]) => ({ [key]: value }));
  }

  // const resetFilterOnTextChange=() =>{
  //   setTimeout(() => {
  //     const options = getUniqueOptions('');
  //     console.log(options);
  //   const newSelected = {};
  //   options.forEach((option) => {
  //     newSelected[option] = true;
  //   });
  //   setSelectedOptions(newSelected);
  //   setAllSelected(true);
  //   }, 1000);
    
  // }

  const handleSelectAll = () => {
    const options = getUniqueOptions('');
    const newSelected = {};
    if (!allSelected) {
      options.forEach((option) => {
        newSelected[option] = true;
      });
    }
    setSelectedOptions(newSelected);
    setAllSelected(!allSelected);
  };

  useEffect(() => {
    const filteredOptions = getUniqueOptions();

    const newSelected = {};
    filteredOptions.forEach((option) => {
      newSelected[option] = true;
    });
    setSelectedOptions(newSelected);  
    setAllSelected(true);
 
  }, [searchText,data]);

  const getUniqueOptions = (from) => {
    var displayFilterOptions=[];
    data.map(market => {
      const marketName = Object.keys(market)[0];       
      const marketInfo = market[marketName];
       displayFilterOptions.push(marketName);
       //defaultExpanded[`market-${marketName}`] = true;
       marketInfo.mu_level_metrics.map((muObj, idx) => {
         const mu = Object.keys(muObj).find(k => !k.includes('md_level_metrics') && !k.includes('dl_level_metrics'));
         const muKey = `${marketName}->${mu}`;
         displayFilterOptions.push(muKey);
         //defaultExpanded[`mu-${marketName}-${mu}`] = true;
         Object.entries(muObj)
                           .filter(([k]) => k.includes('dl_level_metrics'))
                           .flatMap(([empKey, emps], sid) => (
                             Object.entries(emps).map(([empName, markets], secIdx) => {
                               //defaultExpanded[`${muKey}-emp-${empName}`] =true;
                               const empkey= `${muKey}->${empName}`
                               displayFilterOptions.push(empkey);
                               Object.entries(markets.tms_level).map((tmsLevel, tmsidx) => {
                                displayFilterOptions.push(`${empkey}->${tmsLevel[0]}`);
                               })
     })));
    });
    });


    // setAllSelected(!allSelected);
    //console.log('displayFilterOptions',displayFilterOptions)
    const filteredOptions = displayFilterOptions.filter((option) => 
      (option ?? "").toString().toLowerCase().includes(searchText.toLowerCase()));

    return filteredOptions;
  }

  const expandAll = () => {
     const defaultExpanded = {};
    // setLoading(true);
     data.map(market => {
       const marketName = Object.keys(market)[0];       
       const marketInfo = market[marketName];
        defaultExpanded[`market-${marketName}`] = true;
        marketInfo.mu_level_metrics.map((muObj, idx) => {
          const mu = Object.keys(muObj).find(k => !k.includes('md_level_metrics') && !k.includes('dl_level_metrics'));
          const muKey = `mu-${marketName}-${mu}`;
          defaultExpanded[`mu-${marketName}-${mu}`] = true;
          Object.entries(muObj)
                            .filter(([k]) => k.includes('dl_level_metrics'))
                            .flatMap(([empKey, emps], sid) => (
                              Object.entries(emps).map(([empName, markets], secIdx) => {
                                defaultExpanded[`${muKey}-emp-${empName}`] =true;                                
      })));
     });
     });
    setExpanded(defaultExpanded);
    setIsExpanded(false);
   // setLoading(false);
  };

  const collapseAll = () => {
    const defaultExpanded = {};
     data.map(market => {
       const marketName = Object.keys(market)[0];       
        defaultExpanded[`market-${marketName}`] = false;
     });
    setExpanded(defaultExpanded);
    setIsExpanded(true);
  };

  const formatDate = (dateStr) => {
    // Check basic format yyyy-mm-dd using regex
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateStr)) {
      return "";
    }
  
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      return "";
    }
  
    // Format: dd-MMM-yyyy
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };


  useEffect(() => {
    // Trigger whenever selectedFilter updates
    console.log('selectedFilter updated:', selectedFilter);
    const filteredData =(data.filter((marketData) => {
      return Object.keys(marketData).some((marketName) => selectedFilter.includes(marketName));
    }));
        setFilteredData(filteredData);
  }, [selectedFilter]);


  const handleReset= () => {
    const defaultExpanded={};
   // const filteredData
   
    const filteredData =(data.filter((marketData) => {
      defaultExpanded[`market-${marketData}`] = false;
      return Object.keys(marketData).some((marketName) => selectedFilter.includes(marketName));
    }));
        //setFilteredData(filteredData);
        setExpanded(defaultExpanded);
        setFilteredData(filteredData);           
        setFilterVisible(false);
  }

  const getToolUrl = (check) => {  
    if(check=='AGT Submission Pending  (Tools / Assets details)') check='AGT Defaulter';
    return nonCompliance[check] && nonCompliance[check].toolUrl ? nonCompliance[check].toolUrl:'';
  };
  const getMarketDL = (check,market) => {
    let id='';
    switch (market) {
      case 'Americas':
        id='IS.ATCI.AMR';
        break;
    
      case 'Data & AI':
      case 'Industry X':
      case 'Infrastructure-Engineering':
      case 'Software & Platform Engineering':
        id='IS.ATCI.M1';
        break;
    
      case 'EMEA':
        id='IS.ATCI.EMEA';
        break;

      case 'Cloud First':
        id='IS.ATCI.Cloudfirst';
        break;

      case 'Accenture Song':
        id='IS.ATCI.Song';
        break;

      case 'Asia Pacific':
        id='IS.ATCI.APAC';
        break;

      case 'EP':
        id='IS.ATCI.ENT_PLATFORM';
        break;

      case 'Accenture Security':
      case 'CIO':
        id='N/A';
        break;
    
      default:
        id='N/A';
    }
    let displaycheck='';
    // if(check==='CC Overdue')
    //   displaycheck='Contract Compliance overdue. Please reach out to Market specific distro\'s/your assigned coach for taking action.';
    // else if(check==='PSVA Overdue')  
    //   displaycheck='Project Security and Vulnerability Assessment Overdue. Please reach out to Market specific distro\'s/your assigned coach  for taking action.';
    if(id!=='N/A'){
      displaycheck+=' Distro details for '+market+': '+id;
    }
    return displaycheck;
  };
  const getToolType = (check) => {
     if(check=='AGT Submission Pending  (Tools / Assets details)') check='AGT Defaulter';   
    return nonCompliance[check] && nonCompliance[check].type ? nonCompliance[check].type:'';
  };
  const getToolDetails = (check) => {
     if(check=='AGT Submission Pending  (Tools / Assets details)') check='AGT Defaulter';   
    return nonCompliance[check] && nonCompliance[check].Details ? nonCompliance[check].Details:'';
  };

  const openModalChecks = (empName,mu,market,emps) => {
    //console.log('emps,mu,market',emps,mu,market);
    setDisplayEmpName(empName);
    setDisplayMu(mu);
    setDisplayMarket(market);
    setOpenModal(true);
    const checksDetialsObj = {};
    let totalempcount=0;
    if(emps && emps[empName] && emps[empName].tms_level){
    for (const group in emps[empName].tms_level) {
      const groupData = emps[empName].tms_level[group];
      for (const key in groupData) {
        const entry = groupData[key];
    
        if (!entry || typeof entry.count !== 'number' || typeof entry.line_items !== 'string') {
          continue; // skip invalid data
        }
    
        if (!checksDetialsObj[key]) {
          checksDetialsObj[key] = { count: 0, line_items: [], totalline_items:[] };
        }
    
        checksDetialsObj[key].count += entry.count;
        totalempcount+=entry.count;
        // Split by semicolon and trim each item
        const items = entry.line_items.split(';').map(item => item.trim()).filter(Boolean);
        //checksDetialsObj[key].line_items.push(...items);

        items.forEach(item => {
          checksDetialsObj[key].totalline_items.push(item);
          if (!checksDetialsObj[key].line_items.includes(item)) {
            checksDetialsObj[key].line_items.push(item);
          }
        });

      }
    } 
    console.log('checksDetialsObj',checksDetialsObj);
    setChecksDetials(checksDetialsObj);
    setTolEmpCheckCount(totalempcount);
  }   

  };
  const openModalTmsChecks = (empName,mu,market,emps,tmsName) => {
    setDisplayEmpName(empName);
    setDisplayMu(mu);
    setDisplayMarket(market);
    setdisplayTmsName(tmsName);
    setOpenTmsModal(true);
    const checksDetialsObj = {};
    let totalempcount=0;
    if(emps && emps[empName] && emps[empName].tms_level && emps[empName].tms_level[tmsName]){
 //   for (const group in emps[empName].tms_level[tmsName]) {
      const groupData = emps[empName].tms_level[tmsName];
      for (const key in groupData) {
        const entry = groupData[key];
    
        if (!entry || typeof entry.count !== 'number' || typeof entry.line_items !== 'string') {
          continue; // skip invalid data
        }
    
        if (!checksDetialsObj[key]) {
          checksDetialsObj[key] = { count: 0, line_items: [], totalline_items:[] };
        }
    
        checksDetialsObj[key].count += entry.count;
        totalempcount+=entry.count;
        // Split by semicolon and trim each item
        const items = entry.line_items.split(';').map(item => item.trim()).filter(Boolean);
        //checksDetialsObj[key].line_items.push(...items);
        //entry.totalline_items={ ...entry.line_items };
        items.forEach(item => {
          checksDetialsObj[key].totalline_items.push(item);
          if (!checksDetialsObj[key].line_items.includes(item)) {
            checksDetialsObj[key].line_items.push(item);
          }
        });

      }
 //   } 
    console.log('checksDetialsObj',checksDetialsObj);
    setChecksDetials(checksDetialsObj);
    setTolEmpCheckCount(totalempcount);
  }   

  };



  const handleSort = (column,sortType) => {
    setSortOrder(sortType);
    setSelectedSort(column);
    console.log('filteredData',filteredData);
    var sortedData=filteredData;
    if(column=='Market') {
    sortedData = [...sortedData].sort((a, b) => {
      const keyA = Object.keys(a)[0];
      const keyB = Object.keys(b)[0];
      if(sortType==='asc')
      return keyA.localeCompare(keyB);
      else
      return keyB.localeCompare(keyA);
    });
  } else {
      sortedData = [...sortedData].sort((a, b) => {
      const keyA = Object.keys(a)[0];
      const keyB = Object.keys(b)[0];
      if(sortType==='asc')
      return a[keyA].market_level_metrics[column] - b[keyB].market_level_metrics[column]; // asc order
      else 
      return b[keyB].market_level_metrics[column] - a[keyA].market_level_metrics[column]; // desc order
      
    }); 
  }

    console.log('sortedData',sortedData);
    setFilteredData(sortedData);
    
  };

  const handlePlotRendered = () => {
    console.log('inside handlePlotRendered');
    setTimeout(() => {
  setLoading(false); 
}, 8000);
     };

  if (error) { navigate(`/error`) }

  return (
    <>
    <div className={!(showModal || openModal || openTmsModal) ? "container mt-4" :"container mt-4 blur-background"}>
    {/* <div className={openModal || openTmsModal ? 'container blurred' : 'container'}> */}
      <Navbar />
      <div className='projectHeader' id="projectHeader">
           <span className="projectHeaderTms"> ATCi - Weekly Delivery Lead Scorecard </span>
      </div>
      <Container className="mt-4 totalClient" id='totalClient'>
      {loading && <Loader />} 
      <div className='divContainer totalClient'>
        {/* <div className='divDLscore'> */}
        <div className='divDeliveryLeadScore d-flex justify-content-between p-3'>
        <div class="card w-25   p-2">
  <div className="card-body">
    <h5 className="card-title">Delivery Lead Score</h5>
    <p className="card-text">{DLScore}</p>
  </div>
</div>
<div className='p-2 w-25'>
     
      <p><strong>Reporting Period</strong></p>
      <p>{formatDate(dlScoreData.report_date)}</p>
     
    </div>
        </div>
        {/* </div> */}
      <div className='totalDlScoreCardDiv'>
      <ul className="nav nav-pills mb-3 displayTab" id="pills-tab" role="tablist">
        
      <li className="nav-item" role="presentation">
        <button className="nav-link active" id="pills-summary-tab" data-bs-toggle="pill" data-bs-target="#pills-summary" type="button" role="tab" aria-controls="pills-summary" aria-selected="false">Summary</button>
      </li>
      <li className="nav-item" role="presentation">
        <button className="nav-link" id="pills-soreboard-tab" data-bs-toggle="pill" data-bs-target="#pills-soreboard" type="button" role="tab" aria-controls="pills-soreboard" aria-selected="true">Scoreboard</button>
      </li>
      </ul>
      <div className="tab-content dlScoreCardTab" id="pills-tabContent">
      
     <div className="tab-pane fade show active" id="pills-summary" role="tabpanel" aria-labelledby="pills-summary-tab">
      <div className='d-flex justify-content-between p-3 row'>
      <div className='col-8 widthmarket'>
        <div className='title'><strong>Total Non Compliance Score by Market</strong></div>
      <Plot
      onAfterPlot={handlePlotRendered}     
      data={[
        {
          type: 'bar',
          orientation: 'h',
          x: marketListValue,
          y: marketList,
          text: marketListValue,
          hoverinfo: 'skip',
          textposition: 'inside',
          marker: { color: "#082D73" }
        },
      ]}
      config={{ displayModeBar: false }}
      layout={{
        xaxis: {
          visible: false, 
        },
        yaxis: {
          title: {
            text: "Market",
            standoff: 20,
          },
          tickpadding: 20, 
          showline: true,
          linewidth: 1,
          linecolor: '#000',
          //bargroupgap: 0.2,
          tickfont: {
            size: 14,
          },
        },
        margin: { l: 320, r: 10, t: 50, b: 30 },
        height: 500,
        bargap:Math.min(0.9, Math.max(0.1, 1 / marketListValue.length))
      }}
    />
        </div>
        <div className='col-4 widthcheck'>
        <div className='title'><strong>Total Non Compliance Score by Category</strong></div>
        <Plot
      data={[
        {
          type: 'bar',
          orientation: 'h',
          x: checkListValue,
          y: checkList,
          text: checkListValue,
          hoverinfo: 'skip',
          textposition: 'inside',
          marker: { color: "#0041F0" }
        },
      ]}
      config={{ displayModeBar: false }}
      layout={{
        xaxis: {
          visible: false, // 👈 hides the entire x-axis
        },
        yaxis: {
          title: {
            text: "Non-Compliance Score",
            standoff: 20,
          },
          tickpadding: 20, // 👈 Add space between tick labels and y-axis line
          showline: true,
          linewidth: 1,
          linecolor: '#000',
          tickfont: {
            size: 12,
          },
        },
        margin: { l: 200, r: 0, t: 100, b: 0 },
        height: 300,
       // bargap:Math.min(0.9, Math.max(0.1, 1 / checkListValue.length))
      }}
    />
      </div>
      </div>
      <div className='d-flex justify-content-between p-3 row'>
      <div className='col-8 widthmarket'>
        <div className='title'><strong>Top 5 issues that are most defaulted</strong></div>
      <Plot
      data={[
        {
          type: 'bar',
          orientation: 'h',
          x: top5ListValue,
          y: top5List,
          text: top5ListValue,
          hoverinfo: 'skip',
          textposition: 'inside',
          marker: { color: "#082D73" }
        },
      ]}
      config={{ displayModeBar: false }}
      layout={{
        xaxis: {
          visible: false, 
        },
        yaxis: {
          title: {
            text: "Top 5 issues",
            standoff: 20,
          },
          tickpadding: 20, 
          showline: true,
          linewidth: 1,
          linecolor: '#000',
          tickfont: {
            size: 14,
          },
        },
        margin: { l: 370, r: 0, t: 50, b: 30 },
        height: 500,
       // bargap:Math.min(0.9, Math.max(0.1, 1 / top5ListValue.length))
      }}
    />
        </div>
        <div className='col-4 widthcheck'>
        <div className='title'><strong>Market Unit with most TMS in default list</strong></div>
        <Plot
      data={[
        {
          type: 'bar',
          orientation: 'h',
          x: muTop5ListValue,
          y: muTop5List,
          text: muTop5ListValue,
          hoverinfo: 'skip',
          textposition: 'inside',
          marker: { color: "#0041F0" }
        },
      ]}
      config={{ displayModeBar: false }}
      layout={{
        xaxis: {
          visible: false, 
        },
        yaxis: {
          title: {
            text: "Market Unit",
            standoff: 20,
          },
          tickpadding: 20, 
          showline: true,
          linewidth: 1,
          linecolor: '#000',
          tickfont: {
            size: 14,
          },
        },
        margin: { l: 320, r: 30, t: 150, b: 0 },
        height: 300,
        bargap:Math.min(0.9, Math.max(0.1, 1 / muTop5ListValue.length))
      }}
    />
      </div>
      </div>
     </div> 
     <div className="tab-pane fade show" id="pills-soreboard" role="tabpanel" aria-labelledby="pills-soreboard-tab">
     <div><span className="displayExpandAll exportBtn">{filteredData && <ExportExcel userId={userId} filteredData={data} totalDLScore={DLScore} reportDate={formatDate(dlScoreData.report_date)} fileName="DL ScoreCard Report.xlsx"/> } </span>
     </div>
     <div className="d-inline-flex rounded-pill overflow-hidden border border-1 displayExpandAll" id="displayExpandAll">
     <button
        className={`btn ${!isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
        onClick={expandAll}
        style={{ borderRight: '1px solid #ccc' }}
      >
        Expand All
      </button>
      <button
        className={`btn ${isExpanded ? 'text-white bg-purple' : 'bg-white'} rounded-0`}
        onClick={collapseAll}
      >
        Collapse all
      </button>

    </div>
     <div className='displayDivDlTable'>
      <table className="table table-bordered smart-table displayDlTable">
        <thead >
          <tr>
            <th rowSpan="2" className="position-relative">
                Market 
                <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer",float:"right" }} onClick={() => setFilterVisible('Market')}></i>
                {sortOrder === 'asc' ? (
                <FaSortAmountDown style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Market','desc')} />
              ) : (
                <FaSortAmountUp style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Market','asc')} />
              )}       
              {filterVisible && (
                  <div
                    className="border p-2 bg-white shadow-sm position-absolute filter-popup"
                    style={{
                      top: "100%",
                      left: "0",
                      width: "1600px",
                      maxWidth: "1800px",
                      zIndex: 1050,
                    }}
                  >
                    <div className="mb-2 fw-bold">{`Filter Data`}</div>
                    <div class="input-container">
                        <input
                          type="text"
                          className="form-control mb-2 input-underline"
                          placeholder="Search..."
                          value={searchText}
                          class="input-underline"
                          onChange={(e) => {setSearchText(e.target.value)}}
                        />
                        <i class="bi bi-search search-icon"></i> 
                     </div>
                     <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={allSelected}
                        onChange={handleSelectAll}
                      />
                      <label className="form-check-label selectAllLabel float-start" htmlFor="selectAll">
                        Select All
                      </label>
                    </div>
                    <hr/>
                    <div style={{ maxHeight: "200px", overflowY: "auto"}} className='getUniqueOptions'>
                    {getUniqueOptions('html').map((marketName, idx) => {
                  // const marketName = Object.keys(market)[0];
                  return (
                    <div key={idx} className="form-check">
                      <input
                        className="form-check-input selectAllInput"
                        type="checkbox"
                        id={`check-${marketName}`}
                        checked={!!selectedOptions[marketName]}
                        onChange={() => handleCheckboxChange(marketName)}
                      />
                      <label className="form-check-label float-start" htmlFor={marketName}>
                        {marketName}
                      </label>
                    </div>
                  );
                })}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setFilterVisible(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleApply}
                      >Apply</button>
                    </div>
                  </div>
                )}            
            </th>
            <th colspan="5">Non Compliance Score</th>            
            <th rowSpan="2">Total NC Score {sortOrder === 'asc' ? (
                <FaSortAmountDown style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Total','desc')} />
              ) : (
                <FaSortAmountUp style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Total','asc')} />
              )}</th>
            </tr>
            <tr>
            <th>Delivery Governance KPI{sortOrder === 'asc' ? (
                <FaSortAmountDown style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort("Delivery Governance KPIs",'desc')} />
              ) : (
                <FaSortAmountUp style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort("Delivery Governance KPIs",'asc')} />
              )}</th>
            <th>ISA Compliance{sortOrder === 'asc' ? (
                <FaSortAmountDown style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('ISA Compliance tracking KPIs','desc')} />
              ) : (
                <FaSortAmountUp style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('ISA Compliance tracking KPIs','asc')} />
              )}</th>
            <th>Tool Compliance{sortOrder === 'asc' ? (
                <FaSortAmountDown style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('ATCI Tool KPIs','desc')} />
              ) : (
                <FaSortAmountUp style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('ATCI Tool KPIs','asc')} />
              )}</th>
            <th>Training Compliance{sortOrder === 'asc' ? (
                <FaSortAmountDown style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Training KPIs','desc')} />
              ) : (
                <FaSortAmountUp style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Training KPIs','asc')} />
              )}</th>
            <th>Review Compliance{sortOrder === 'asc' ? (
                <FaSortAmountDown style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Review KPIs','desc')} />
              ) : (
                <FaSortAmountUp style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={()=> handleSort('Review KPIs','asc')} />
              )}</th>
          </tr>
        </thead>
        <tbody className="scrollableTableBodyDL">
          {filteredData.map((market, index) => {
            const marketName = Object.keys(market)[0];
            const marketInfo = market[marketName];            
            return (
              <React.Fragment key={index}>
                <tr onClick={() => toggle(`market-${marketName}`)} style={{ cursor: 'pointer' }}>
                  <td><span className="displaySign"> {expanded[`market-${marketName}`] ? '-' : '+'}</span> <strong>{'\u2003'+marketName}</strong></td>
                  <td><strong>{marketInfo?.market_level_metrics?.["Delivery Governance KPIs"] || ""}</strong></td>
                  <td><strong>{marketInfo?.market_level_metrics?.['ISA Compliance tracking KPIs'] || ""}</strong></td>
                  <td><strong>{marketInfo?.market_level_metrics?.['ATCI Tool KPIs'] || ""}</strong></td>
                  <td><strong>{marketInfo?.market_level_metrics?.['Training KPIs'] || ""}</strong></td>
                  <td><strong>{marketInfo?.market_level_metrics?.['Review KPIs'] || ""}</strong></td>
                  <td><strong>{marketInfo?.market_level_metrics?.['Total'] || ""}</strong></td>
                  </tr>
                {expanded[`market-${marketName}`] &&
                  marketInfo.mu_level_metrics.map((muObj, idx) => {
                    const mu = Object.keys(muObj).find(k => !k.includes('md_level_metrics') && !k.includes('dl_level_metrics'));
                    const muInfo = muObj[mu];
                    const muKey = `mu-${marketName}-${mu}`;
                    return (
                      <React.Fragment key={idx}>
                        <tr className="table-secondary" onClick={() => toggle(muKey)} style={{ cursor: 'pointer' }}>
                          <td><span className="displaySign secondary">{expanded[muKey] ? '-' : '+'} </span>  {'\u2003'+mu}</td>
                          <td><strong>{muInfo?.["Delivery Governance KPIs"] || ""}</strong></td>
                          <td><strong>{muInfo?.['ISA Compliance tracking KPIs'] || ""}</strong></td>
                          <td><strong>{muInfo?.['ATCI Tool KPIs'] || ""}</strong></td>
                          <td><strong>{muInfo?.['Training KPIs'] || ""}</strong></td>
                          <td><strong>{muInfo?.['Review KPIs'] || ""}</strong></td>
                          <td><strong>{muInfo?.['Total'] || ""}</strong></td>
                        </tr>
                          {expanded[muKey] && (
                          Object.entries(muObj)
                            .filter(([k]) => k.includes('dl_level_metrics'))
                            .flatMap(([empKey, emps], sid) => (
                              Object.entries(emps).map(([empName, markets], secIdx) => {
                                const empKeyFull = `${muKey}-emp-${empName}`;
                                console.log('emps',emps)
                                return (
                                  <React.Fragment key={secIdx}>
                                    {/* <tr className="table-light" onClick={() => toggle(empKeyFull)} style={{ cursor: 'pointer' }}> openModalChecks(emps,mu,market) */}
                                    <tr className="table-light" onClick={() => toggle(empKeyFull)} style={{ cursor: 'pointer' }}>
                                      <td><span className="displaySign third">{expanded[empKeyFull] ? '-' : '+'}</span> <span className="empName" onClick={(e) => {e.stopPropagation(); openModalChecks(empName,mu,marketName,emps) }} title='Click here to view more details on non compliance checks'>{'\u2003'+empName}</span></td>
                                      <td><strong>{ emps?.[empName]?.dl_level?.["Delivery Governance KPIs"] || ""}</strong></td>
                                      <td><strong>{ emps?.[empName]?.dl_level?.['ISA Compliance tracking KPIs'] || ""}</strong></td>
                                      <td><strong>{ emps?.[empName]?.dl_level?.['ATCI Tool KPIs'] || ""}</strong></td>
                                      <td><strong>{ emps?.[empName]?.dl_level?.['Training KPIs'] || ""}</strong></td>
                                      <td><strong>{ emps?.[empName]?.dl_level?.['Review KPIs'] || ""}</strong></td>
                                      <td><strong>{ emps?.[empName]?.dl_level?.['Total'] || ""}</strong></td>
                                    </tr>
                                    { expanded[empKeyFull] && ( Object.entries(markets.tms_level).map((tmsLevel, tmsidx) => {
       return (
        <React.Fragment key={'tms'+tmsidx}>
      <tr key={tmsidx} onClick={() => openModalTmsChecks(empName,mu,marketName,emps,tmsLevel[0])} style={{ cursor: 'pointer' }}>
        <td style={{ paddingLeft: `${80}px` }} title='Click here to view more details on non compliance checks'>{tmsLevel && tmsLevel[0]?tmsLevel[0]:''}</td>
        <td>{tmsLevel && tmsLevel[1] && tmsLevel[1]['Delivery Governance KPIs']?tmsLevel[1]['Delivery Governance KPIs']?.count:''}</td>
        <td>{tmsLevel && tmsLevel[1] && tmsLevel[1]['ISA Compliance tracking KPIs']?tmsLevel[1]['ISA Compliance tracking KPIs']?.count:''}</td>
        <td>{tmsLevel && tmsLevel[1] && tmsLevel[1]['ATCI Tool KPIs']?tmsLevel[1]['ATCI Tool KPIs']?.count:''}</td>
        <td>{tmsLevel && tmsLevel[1] && tmsLevel[1]['Training KPIs']?tmsLevel[1]['Training KPIs']?.count:''}</td>
        <td>{tmsLevel && tmsLevel[1] && tmsLevel[1]['Review KPIs']?tmsLevel[1]['Review KPIs']?.count:''}</td>
        <td>{(tmsLevel[1]?.['Delivery Governance KPIs']?.count ?? 0) + (tmsLevel[1]?.['ISA Compliance tracking KPIs']?.count ?? 0) + (tmsLevel[1]?.['ATCI Tool KPIs']?.count ?? 0) + (tmsLevel[1]?.['Training KPIs']?.count ?? 0) + (tmsLevel[1]?.['Review KPIs']?.count ?? 0)}</td>
      </tr>
      </React.Fragment>
    )}
))}
                                   </React.Fragment>
                                );
                              })
                            ))
                        )}
                      </React.Fragment>
                    );
                  })}
              </React.Fragment>
            )
          })}
        </tbody>
      </table>    
      </div>     
      <div className='mt-2'><a className="blueColor fs-14" onClick={() => setShowModal(true)}>
       Click here to view all check details
      </a></div> 
     </div> 
         
     {showFeedback && (<FeedbackWidget moduleName="DLScoreCard_Web" onSubmit={() => setShowFeedback(false)}/>)}
    
     </div>      
     </div>
     <div className="footerText">Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.</div>
      </div> 
      {loading && <Loader />}     
      </Container>
    </div>
    {openModal && (
        <div className="modal" style={{ display: 'block', '--bs-modal-width': '80%'        }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fs-14">Non Compliance Score</h5>
                <button type="button" className="btn-close" onClick={() => setOpenModal(false)}></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                          <div className='fs-14 mb-1'> {displayMarket} &gt; {displayMu} </div>
                              <div className='d-flex justify-content-between p-2 border mb-1'>
                <div className='p2 fs-14'>Delivery Lead: <span className='empid'>{displayEmpName}</span></div>
                <div className='p2 totalscr fs-14'>Total NC Score: {tolEmpCheckCount}</div>
                </div>
                <div className="form-check ps-0">
                <table class="table table-striped modalTable smart-table fs-14">
                <thead>
                  <tr>
                    <th>Non Compliance Checks</th>
                    <th>Score</th>
                    <th>Remediation Details</th>
                    <th>Tool URL</th>
                  </tr>
                </thead>
                <tbody>
                   
                  {( Object.entries(checksDetials).map((tmsLevel, tmsidx) => {
                     return (
                    <React.Fragment>
                    <tr><td colSpan="4"><div className="d-flex justify-content-start fw-semibold">{tmsLevel[0]}</div></td></tr>
                    {tmsLevel[1].line_items.map((c, tmsidx) => { 
                       return (
                      <React.Fragment>
                   <tr>
                    
                    {console.log('c',c)}
                     <td>{c}</td>
                     <td>{tmsLevel[1].totalline_items.filter(item => item === c).length}</td>    
                     <td  dangerouslySetInnerHTML={{ __html: getToolDetails(c) }} />
                     {getToolType(c)==='url' &&
                     <td><a target="_blank" href={getToolUrl(c)}>
                     {getToolUrl(c)}</a></td> }
                     {getToolType(c)==='text' &&
                     <td>{getToolUrl(c)}</td> }
                     {getToolType(c)==='market' &&
                     <td>{getMarketDL(c,displayMarket)}</td> }
                   </tr>
                   </React.Fragment> )
                  })}
                  </React.Fragment>
                      );
                  }))} 
               </tbody>
              </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openTmsModal && (
        <div className="modal" style={{ display: 'block', '--bs-modal-width': '80%'        }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fs-14">Non Compliance Score TMS Level</h5>
                <button type="button" className="btn-close" onClick={() => setOpenTmsModal(false)}></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                <div className='fs-14 mb-1'>{displayMarket} &gt; {displayMu} &gt; {displayEmpName} </div>               
                <div className='d-flex justify-content-between p-2 border mb-1'>
                <div className='p2 fs-14'>TMS Name: <span className='empid'>{displayTmsName}</span></div>
                <div className='p2 totalscr fs-14'>Total NC Score: {tolEmpCheckCount}</div>
                </div>
                <div className="form-check ps-0">
                <table class="table table-striped modalTable smart-table fs-12">
                <thead>
                  <tr>
                    <th>Non Compliance Checks</th>
                    <th>Score</th>
                    <th>Remediation Details</th>
                    <th>Tool URL</th>
                  </tr>
                </thead>
                <tbody>
                   
                  {( Object.entries(checksDetials).map((tmsLevel, tmsidx) => {
                     return (
                    <React.Fragment>
                    <tr><td colSpan="4"><div className="d-flex justify-content-start fw-semibold">{tmsLevel[0]}</div></td></tr>
                    {tmsLevel[1].line_items.map((c, tmsidx) => { 
                       return (
                      <React.Fragment>
                   <tr>
                    
                    {console.log('c',c)}
                     <td>{c}</td>
                     <td>{tmsLevel[1].totalline_items.filter(item => item === c).length}</td>
                     <td  dangerouslySetInnerHTML={{ __html: getToolDetails(c) }} />                    
                     {getToolType(c)==='url' &&
                     <td><a target="_blank" href={getToolUrl(c)}>
                     {getToolUrl(c)}</a></td> }
                     {getToolType(c)==='text' &&
                     <td>{getToolUrl(c)}</td> }
                     {getToolType(c)==='market' &&
                     <td>{getMarketDL(c,displayMarket)}</td> }
                   </tr>
                   </React.Fragment> )
                  })}
                  </React.Fragment>
                      );
                  }))} 
               </tbody>
              </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title nonComplianceTitle">DL Non-Compliance Checks Reference</h3>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                <table className="table table-bordered smart-table modalTable deliveryTable fs-6">
                  <thead>
                    <tr>
                      <th>Category wise non-compliance checks</th>
                      <th>Tool URL/Distribution List for remediation</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr key='1' className="">
                        <td colSpan='3' className="text-start fw-semibold">Tool Compliance</td>
                      </tr>                     
                      
                      <tr key='4'>
                        <td className="text-start">PACT Overdue</td>
                        <td className="text-start"><a target="_blank" href="https://atcidelivery.accenture.com/Central/secure-delivery/pact/pactDashboard">https://atcidelivery.accenture.com/Central/secure-delivery/pact/pactDashboard</a></td>
                        <td className="text-start">Production Inventory Control tool - submission required</td>
                      </tr>
                      <tr key='5'>
                        <td className="text-start">Peak Season Readiness</td>
                        <td className="text-start"><a target="_blank" href="https://atcidelivery.accenture.com/Central/special-focus/seasonal-spike/spikeLanding">https://atcidelivery.accenture.com/Central/special-focus/seasonal-spike/spikeLanding</a></td>
                        <td className="text-start">Seasonal spike tool - submisison required</td>
                      </tr>
                      <tr key='6'>
                        <td className="text-start">SDAT Submission NOT completed</td>
                        <td className="text-start"><a target="_blank" href="https://atcidelivery.accenture.com/Central/secure-delivery/sdat/secureADDashboard">https://atcidelivery.accenture.com/Central/secure-delivery/sdat/secureADDashboard</a></td>
                        <td className="text-start">Secure Delivery Assessment Tool  - submission required</td>
                      </tr>
                      <tr key='61one'>
                        <td className="text-start">GenAI scaled-status misalignment between MMD and GenAI portal</td>
                        <td className="text-start"><a target="_blank" href="https://atcidelivery.accenture.com/Central//special-focus/gen-aitracking/genAITrackingLanding">https://atcidelivery.accenture.com/Central//special-focus/gen-aitracking/genAITrackingLanding</a></td>
                        <td className="text-start">Scaling section to be added / enabled in <b>GenAI portal</b> as MMD GenAI status is marked scaling for TDLC. Delivery Leads to reach out to DEx PoCs for creating the scaled entry in GenAI portal. If incorrect status in MMD, it needs to be fixed.</td>
                      </tr>
                      <tr key='62two'>
                        <td className="text-start">GenAI scaling details not submitted for productivity overdue projects</td>
                        <td className="text-start"><a target="_blank" href="https://atcidelivery.accenture.com/Central/special-focus/gen-aitracking/genAITrackingLanding">https://atcidelivery.accenture.com/Central/special-focus/gen-aitracking/genAITrackingLanding</a></td>
                        <td className="text-start">Scaling section to be enabled in <b>GenAI portal</b> as Productivity Start Date is past and GenAI RAG is green in committed section which means GenAI use cases are successfully deployed to production environment. However, if project is still not in scaling , update the GenAI RAG to amber with appropriate RAG comments in committed section of GenAI portal. Also update the MMD GenAI status accordingly.</td>
                      </tr>
                      <tr key='7'>
                        <td colSpan='3' className="text-start fw-semibold">Delivery Governance KPI</td>
                      </tr>
                      <tr key='8'>
                        <td className="text-start">Code Coverage Not Reported</td>
                        <td className="align-middle text-center align-middle-important" rowSpan='17'><div style={{ width: '100%' }}><a target="_blank" href="https://mywizarddm.accenture.com/">https://mywizarddm.accenture.com/</a></div></td>
                        <td className="text-start">Unit test code coverage metric to be reported for Projects having coding in scope.
Pls note: For this KPI, both not reported and Reporting as 0 is considered. If it is NIS(Not in scope) , pls configure in TMS structure in myWizard. 
</td>
                      </tr>
                      <tr key='8_1'>
                        <td className="text-start">Delivered Defect rate - Not Reported</td>
                        <td className="text-start">Delivered Defect rate' metric to be reported for Projects having coding in scope.If it is NIS(Not in scope) , pls configure in TMS structure Console in MMD. <br/><br/><u>Conventional Releases:</u> (If the 'Current phase of the project' field is reported beyond Build (<u>in any Test phase / Deploy stages</u>) Rate at which defects are detected by client team/client/3rd party(external) w.r.t total effort is expected to be reported.<br/><br/><u>For Agile Releases :</u> Indicates the effectiveness of the review and testing activities. This is ratio of defects delivered from the release to the total effort spent to deliver the release. This metric can be calculated when the release is ongoing.<br/><br/>If none detected till the current reporting week, please report as 0.</td>
                      </tr> 
                      <tr key='8_2'>
                        <td className="text-start">Delivered Defect rate above threshold</td>
                        <td className="text-start">The Delivered defect rate metric reported is above &gt; 0.003 ( Global Standard threshold)  to indicate a quality risk.<br/><br/>Recommend to report Delivery status as 'At Risk/Alert' accordingly in the Narratives section of MMD post review(if not already done).</td>
                      </tr>
                      <tr key='9'>
                        <td className="text-start">Metrics submission defaulter</td>
                        <td className="text-start">Weekly metrics submission is NOT completed/ Partial/ submitted after cut-off time.</td>
                      </tr>
                      <tr key='10'>
                        <td className="text-start">Milestones NOT configured</td>
                        <td className="text-start">Application development contracts to have an <b>active</b> milestone created in myWizard (excluding program/E2E start and end dates).</td>
                      </tr>
                      <tr key='11'>
                        <td className="text-start">Narratives Submission defaulter</td>
                        <td className="text-start">Delivery dashboard(Narratives) submission is not completed/ submitted after cut-off time.</td>
                      </tr>
                      <tr key='11one'>
                        <td className="text-start">MMD submission done by TL or below resource </td>
                        <td className="text-start">MMD Narratives submission to be done by AM or above resource.</td>
                      </tr>
                      <tr key='11New'>
                        <td className="text-start">GenAI status not reported in MMD</td>
                        <td className="text-start">GenAI section is not reported in Delivery dashboard(Narratives) console.</td>
                      </tr>
                      <tr key='12'>
                        <td className="text-start">Overdue Action Items</td>
                        <td className="text-start">Actions tagged to the project level is open and overdue.</td>
                      </tr>
                      <tr key='13'>
                        <td className="text-start">RED / AMBER Project with risk/ Issues NOT configured</td>
                        <td className="text-start">
Projects reporting Overall / Delivery status in Amber/Alert - must have a <b>active</b> Risk/Issue created in myWizard(pls check if due dates are set in future).</td>
                      </tr>
                      <tr key='14'>
                        <td className="text-start">Projects with past end dates</td>
                        <td className="text-start">Team Management structure/ ATCI project(TMS)  has End date configured in past.</td>
                      </tr>
                      <tr key='15'>
                        <td className="text-start">Repeated MMD submission Defaults</td>
                        <td className="text-start">Project has been tagged under Narrative/metrics submisison outlier in both previous and 
                        current week.</td>
                      </tr>
                      <tr key='16'>
                        <td className="text-start">WS with past end dates</td>
                        <td className="text-start">Workstreams under Client Management structure has End date configured in past.</td>
                      </tr>
                      <tr key='161'>
                        <td className="text-start">Total Peak FTE - Not reported</td>
                        <td className="text-start">Total Peak FTE measure needs to be configured/ reported in MMD.</td>
                      </tr>
                      <tr key='162'>
                        <td className="text-start">SMART Project ID not mapped in MMD</td>
                        <td className="text-start">SMART project ID is yet to be prefixed to the TMS(project) name in MMD.</td>
                      </tr>
                      <tr key='163'>
                        <td className="text-start">Re-contracting action pending</td>
                        <td className="text-start">The ATCI project is still tracked under Opportunity. Re-contracting with the required contract number must be completed in MMD console. (Opportunity > 1month based on E2E start date is considered for this KPI’s non-compliance)</td>
                      </tr>
                      <tr key='164'>
                        <td className="text-start">MMD – Delayed project creation</td>
                        <td className="text-start">Projects created in MMD, greater than 4 weeks from ATCI start date will be tagged as delayed creation.
This KPI is only to highlight the delay in project enablement/reporting in Console, and  this is a Quarter- to-date(QTD) tracked  KPI , hence will be persistent till end of the given quarter of the FY.</td>
                      </tr>
                      <tr key='17'>
                        <td colSpan='3' className="text-start fw-semibold">ISA Compliance</td>
                      </tr>
                      <tr key='18'>
                        <td className="text-start">CC Overdue</td>
                        <td className="align-middle text-center align-middle-important" rowSpan='2'><div style={{ width: '100%' }}>Americas : <a target="_blank" href="mailto:IS.ATCI.AMR@accenture.com">IS.ATCI.AMR</a>,<br/> 
Data & AI/Industry X/Infrastructure-Engineering/Software & Platform Engineering   : <a target="_blank" href="mailto:IS.ATCI.M1@accenture.com">IS.ATCI.M1</a>, <br/>
EMEA : <a target="_blank" href="mailto:IS.ATCI.EMEA@accenture.com">IS.ATCI.EMEA</a>,<br/> Cloud First : <a target="_blank" href="mailto:IS.ATCI.Cloudfirst@accenture.com">IS.ATCI.Cloudfirst</a>, <br/>
Accenture Song : <a target="_blank" href="mailto:IS.ATCI.Song@accenture.com">IS.ATCI.Song</a>,<br/>  Asia Pacific : <a target="_blank" href="mailto:IS.ATCI.APAC@accenture.com">IS.ATCI.APAC</a> , <br/>
EP : <a target="_blank" href="mailto:IS.ATCI.ENT_PLATFORM@accenture.com">IS.ATCI.ENT_PLATFORM</a>,<br/> Accenture Security / CIO : N/A </div>
</td>
                        <td className="text-start">Contract Compliance overdue. Pls reach out to Market specific distro's/your assigned coach 
                        for taking action.</td>
                      </tr>
                      <tr key='19'>
                        <td className="text-start">IS Internal Assessment Overdue</td>                       
                        <td className="text-start">Information Security Internal Assessment is overdue. Pls reach out to Market specific distro's/your assigned coach  for taking action.</td>
                      </tr>
                      <tr key='20'>
                        <td colSpan='3' className="text-start fw-semibold">Review Compliance</td>
                      </tr>
                      <tr key='21'>
                        <td className="text-start">PR - Audit Delayed</td>                       
                        <td className="align-middle text-center align-middle-important" rowSpan='4'><div style={{ width: '100%' }}>Direct links mentioned in auto-mailers that gets triggered when reviews are scheduled</div></td>                       
                        <td className="text-start">Process Review : Audit in delayed state.</td>
                      </tr>
                      <tr key='22'>
                        <td className="text-start">PR - MD Approval Delayed</td>                       
                        <td className="text-start">Process Review :MD Approval pending and in delayed state.</td>
                      </tr>
                      <tr key='25'>
                        <td className="text-start">PR - Peer Review Delayed</td>                       
                        <td className="text-start">Process Review : Peer review pending and in delayed state.</td>
                      </tr>
                      <tr key='27'>
                        <td className="text-start">PR - Self-Assessment Delayed</td>                       
                        <td className="text-start">Process Review : PM Self-Assessment pending and in delayed state.</td>
                      </tr>
                      <tr key='28'>
                        <td className="text-start">SGR - MD Approval Delayed</td>                       
                        <td className="align-middle text-center align-middle-important" rowSpan='3'> <div style={{ width: '100%' }}>
                        Direct links mentioned in auto-mailers that gets triggered when reviews are scheduled.</div></td>                       
                        <td className="text-start">Stage Gate Review: MD Approval pending and in delayed state.</td>
                      </tr>
                      <tr key='31'>
                        <td className="text-start">SGR - Self-Assessment Delayed</td>                       
                        <td className="text-start">Stage Gate Review: Self-Assessment by DL/PM pending and delayed state.</td>
                      </tr>
                      <tr key='33'>
                        <td className="text-start">SGR - SME Review Delayed</td>                       
                        <td className="text-start">Stage Gate Review: SME  Review pending and delayed.</td>
                      </tr>
                      <tr key='34'>
                        <td colSpan='3' className="text-start fw-semibold">Training Compliance</td>
                      </tr>
                      <tr key='35'>
                        <td className="text-start">ATCI DL Certification Pending</td>                       
                        <td className="text-start" ><a target="_blank" href='https://atci.lkm.delivery.accenture.com/DLE/'>https://atci.lkm.delivery.accenture.com/DLE/</a></td>                       
                        <td className="text-start">Leads marked as ATCI Delivery leads, are yet to complete the Delivery Lead Essentials (DLE) and CDP certification.The certification status extract used for this KPI is refreshed once in a month.If certification is completed in the current month, pls await next month’s report (published usually within a fortnight)  for the status reflection.</td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DLScoreCard;